import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-google-gemini-large.tsx
/**
* icon.24.logo.google.gemini.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIgM2MuMTg5IDAgLjM1My4xMy40LjMxM3EuMjExLjg0MS41NTQgMS42MzdhMTEuNiAxMS42IDAgMCAwIDIuNDU1IDMuNjQgMTEuNTYgMTEuNTYgMCAwIDAgNS4yOCAzLjAxMi40MTEuNDExIDAgMCAxLS4wMDIuNzk3cS0uODQxLjIxMi0xLjYzNy41NTVhMTEuNiAxMS42IDAgMCAwLTMuNjQgMi40NTUgMTEuNTcgMTEuNTcgMCAwIDAtMy4wMTIgNS4yOEEuNDEuNDEgMCAwIDEgMTIgMjFhLjQxLjQxIDAgMCAxLS4zOTgtLjMxMiAxMS41NSAxMS41NSAwIDAgMC0zLjAxLTUuMjc4IDExLjU2IDExLjU2IDAgMCAwLTUuMjgtMy4wMTJBLjQxLjQxIDAgMCAxIDMgMTJjMC0uMTg4LjEzLS4zNTIuMzEzLS4zOThxLjg0MS0uMjEyIDEuNjM3LS41NTVBMTEuNiAxMS42IDAgMCAwIDguNTkgOC41OWExMS41NiAxMS41NiAwIDAgMCAzLjAxMi01LjI3OEEuNDEuNDEgMCAwIDEgMTIgMyIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=20047-48802
*/
const Icon24LogoGoogleGeminiLarge = memo(function Icon24LogoGoogleGeminiLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12 3c.189 0 .353.13.4.313q.211.841.554 1.637a11.6 11.6 0 0 0 2.455 3.64 11.56 11.56 0 0 0 5.28 3.012.411.411 0 0 1-.002.797q-.841.212-1.637.555a11.6 11.6 0 0 0-3.64 2.455 11.57 11.57 0 0 0-3.012 5.28A.41.41 0 0 1 12 21a.41.41 0 0 1-.398-.312 11.55 11.55 0 0 0-3.01-5.278 11.56 11.56 0 0 0-5.28-3.012A.41.41 0 0 1 3 12c0-.188.13-.352.313-.398q.841-.212 1.637-.555A11.6 11.6 0 0 0 8.59 8.59a11.56 11.56 0 0 0 3.012-5.278A.41.41 0 0 1 12 3",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24LogoGoogleGeminiLarge };

//# sourceMappingURL=icon-24-logo-google-gemini-large.js.map